import { render, staticRenderFns } from "./new_user.vue?vue&type=template&id=051a94df&scoped=true&"
import script from "./new_user.vue?vue&type=script&lang=js&"
export * from "./new_user.vue?vue&type=script&lang=js&"
import style0 from "./new_user.vue?vue&type=style&index=0&id=051a94df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a94df",
  null
  
)

export default component.exports